// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"87842f67","239":"b87b01d3","667":"8f670b1e"}[chunkId] + ".chunk.js";
};